module.exports = __webpack_public_path__ + "static/media/maps-combined_2020-05-01.65c98f46.png";